import { deleteMutationMessage } from '../../utils/messageMutation';
import DeleteTagMutation from '../../_graphql/mutations/documents/DeleteTagMutation';

export const deleteTag = (tagId, cb) =>
  DeleteTagMutation({ tagId }, (ok, error) => {
    deleteMutationMessage(ok, error, 'tag');
    !!cb && cb(ok, error);
  });
